<template>
  <div>
    <v-dialog v-model="dialog" persistent max-width="600px">
      <v-card>
        <v-card-title>
          <span class="titulo-modal">
            Deseja inativar {{ loginUsuarioSelecionado }}?
          </span>
        </v-card-title>
        <v-card-text>
          <span class="fontsize-descricao"
            >Ao confirmar essa opção você estará inativando o usuário.</span
          >
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="white"
            class="btn-primary ml-0 mb-3"
            text
            @click="inativarUsuario"
          >
            <v-progress-circular
              indeterminate
              v-if="carregando"
              color="white"
              :size="25"
              :width="3"
            ></v-progress-circular>
            <div v-else>Sim</div>
          </v-btn>
          <v-btn
            color="primary"
            class="btn-quaternary ml-0 mb-3"
            text
            @click="$emit('fecharModal')"
          >
            Cancelar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import usuarioApi from "@/api/usuario/usuario-api";
import Usuario from "@/model/usuario/Usuario";

export default {
  // props: ["idUsuarioSelecionado"],
  props: {
    idUsuarioSelecionado: { type: Number, require: true },
    loginUsuarioSelecionado: { type: String, require: true },
  },
  data() {
    return {
      carregando: false,
      dialog: true,
    };
  },

  methods: {
    async inativarUsuario() {
      this.carregando = true;
      try {
        const response = await usuarioApi.inativar(this.idUsuarioSelecionado);
        this.$emit("inativarUsuario", new Usuario(response.data));
      } catch (error) {
        this.$emit(
          "erroInativarUsuario",
          (error &&
            error.response &&
            error.response.data &&
            error.response.data.message) ||
            "Não foi possível se comunicar com o servidor!"
        );
      }
      this.carregando = false;
    },
  },
};
</script>

<style lang="scss" scoped>
.fontsize-descricao {
  font-size: 1.1rem;
}
</style>
